import LoginPageImage from "../../assets/LoginPageImage.png";
import { useDispatch, useSelector } from "react-redux";

import { useState, useEffect } from "react";
import { loginUser } from "../../Redux/userSlice";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { updatePassword } from "../../Redux/passResetSlice";
import RegisterPopUp from "../../components/auth/RegisterPopUp";

const Login = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const userRegisterToast = searchParams.get("userRegister");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loading, error } = useSelector((state) => state.user);
  const [loginCookie, setLoginCookie] = useCookies(["user"]);
  const [rememberCheck, setRememberCheck] = useState(loginCookie.RememberMe);
  const [modalOpen, setModalOpen] = useState(false);

  const form = useForm({
    defaultValues: {
      phone: loginCookie.Phone,
      password: loginCookie.Password,
    },
  });
  const {
    register,
    control,
    handleSubmit,
    formState,
    watch,
    setValue,
    getValues,
  } = form;
  const { errors } = formState;
  useEffect(() => {
    if (userRegisterToast === "success") {
      toast.success("User registered successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (userRegisterToast === "registered") {
      toast.success("Expert registered successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }else if (userRegisterToast === "passUpdated"){
      toast.success("Your Password has been updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });

    }
  }, [userRegisterToast]);

  const handleSetCookiesCheck = (e) => {
    if (e.target.checked) {
      setRememberCheck(e.target.checked);
    } else {
      setRememberCheck(false);
      setLoginCookie("Phone", null, {
        path: "/",
        sameSite: "Strict",
        secure: false,
      }); //set samesite to either (none,Lax,or strict as per latest Doc RFC6265bis)
      setLoginCookie("Password", null, {
        path: "/",
        sameSite: "Strict",
        secure: false,
      }); //if  set secure :false it will only work for https secure sites not works for http
      setLoginCookie("RememberMe", false, {
        path: "/",
        sameSite: "Strict",
        secure: false,
      });
      // Strict not allows the cookie to be sent on a cross-site request or iframe. Lax allows GET only. None allows all the requests, but secure is required.
    }
  };

  const onFormSubmit = async (data) => {
    if (rememberCheck) {
      setLoginCookie("Phone", data.phone, {
        path: "/",
        sameSite: "Strict",
        secure: false,
      });
      setLoginCookie("Password", data.password, {
        path: "/",
        sameSite: "Strict",
        secure: false,
      });
      setLoginCookie("RememberMe", rememberCheck, {
        path: "/",
        sameSite: "Strict",
        secure: false,
      });
    } else {
      setLoginCookie("Phone", null, {
        path: "/",
        sameSite: "Strict",
        secure: false,
      });
      setLoginCookie("Password", null, {
        path: "/",
        sameSite: "Strict",
        secure: false,
      });
      setLoginCookie("RememberMe", false, {
        path: "/",
        sameSite: "Strict",
        secure: false,
      });
    }
    let formData = {
      
      password: String(data.password),
      phone: String(`91${data.phone}`),
     

     
    };
   
    dispatch(loginUser(formData)).then((result) => {
      if (result.payload !== "Mobile Number or Password is not valid") {
        navigate("/");
      } else {
        toast.error(result.payload, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    });
  };
  function closeModal(getCloseFlag = "false") {
    setModalOpen(getCloseFlag);
  }

  return (
    
    <>
     
      <div className="login-section ">
      <div className="pc login-left">
        <div className="login-left-section">
          {/* */}
            <img
              className="login-sec-img"
              src={LoginPageImage}
              alt="Paramarsh"
            />
          </div>
        </div>

        <div className="login-right-section rounded-20 mt-10">
          <img className="login-sec-img" src={LoginPageImage} alt="Paramarsh" />
          <h2 className="text-pink text-center text-bold mt-15">Welcome to </h2>
          <h2 className="text-pink text-center text-bold ">Paramasrh Sampark</h2>
          <ToastContainer />

          <form
            className="mt-20"
            onSubmit={handleSubmit(onFormSubmit)}
            noValidate
          >
            <div className="col-md-4  tank-col-info">
              <label htmlFor="phone" className="text-gray text-semi-bold">
                Mobile Number<span className="text-red">*</span>
              </label>
              <input
                  id="phone"
                  {...register("phone", {
                    required: {
                      value: true,
                      message: "Mobile Number field should contains atleast 10 digits",
                    },
                    pattern: {
                      value: /^[0-9]/,
                      message: "Only Digits are Allowed",
                    },
                    minLength: { value: 10, message: "Enter 10 digits" },
                    maxLength: { value: 10, message: "Enter 10 digits" },
                  })}
                  type="text"
                  className="form-control rounded-10 mb-15"
                  placeholder="Enter Mobile Number"
                />
              <p className="text-red mb-10">{errors.phone?.message}</p>
            </div>

            <div className="col-md-4 tank-col-info">
              <label htmlFor="password" className="text-gray text-semi-bold">
                Password
                <span className="text-red">*</span>
              </label>
              <input
                id="password"
                {...register("password", {
                  required: {
                    value: true,
                    message: "Password Field is Required",
                  },
                })}
                type="password"
                className="form-control rounded-10 mb-15"
                placeholder="Enter Password"
              />
              <p className="text-red mb-10">{errors.password?.message}</p>
            </div>

            <div>
              <label
                htmlFor="link-checkbox"
                className="ml-2 text-sm font-medium"
              >
                <input
                  id="link-checkbox"
                  type="checkbox"
                  className="w-4 h-4 mr-1"
                  defaultChecked={loginCookie.RememberMe}
                  onChange={handleSetCookiesCheck}
                />{" "}
                Remember me
              </label>
            </div>

            <input
              type="submit"
              className="btn btn-light-pink btn-full rounded-10 mt-10 mb-10"
              value={loading ? "Loading..." : "Login"}
              // value={"Login"}
              // value = "Sign In"
            />

            <RegisterPopUp modalOpen={modalOpen} closeModal={closeModal} />
            
            <div className="text-Left no-bg">
              <span
                className="text-semi-bold text-pink"
                onClick={() => {
                  navigate("/userRegistration");
                }}
              >
                Register now
              </span>
            </div>
            <div className="text-Left no-bg">
              {/* <span
                className="text-semi-bold text-pink"
                onClick={() => {
                  setModalOpen(true);
                }}
              >
                Forgot Password ?
              </span> */}
               <span
                className="text-semi-bold text-pink"
                onClick={() => {
                  navigate("/forgot-password");
                }}
              >
                Forgot Password ?
              </span>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
export default Login;
